// extracted by mini-css-extract-plugin
export default {"root":"EmbeddedAppLoader_root__kn7Y4","loader":"EmbeddedAppLoader_loader__Kvbf3"};